enum VIDEO_COMPLETED_REASON {
    callDropped = "call dropped",
    endedByPatient = "ended by patient",
    endedByProvider = "ended by provider",
    patientHardClose = "patient hard close",
}
export default VIDEO_COMPLETED_REASON;